// extracted by mini-css-extract-plugin
module.exports = {"Custom_Spinner_Wrap":"Loading_Custom_Spinner_Wrap__1bnws"};